import { RouterProvider } from '@tanstack/react-router'
import { Provider } from 'inversify-react'
import router from './router'
import { Toaster } from './components/ui/sonner'
import { useGetAuth } from './hooks/auth/useGetAuth'
import container from './config/container'

export function App() {
  const auth = useGetAuth()

  return (
    <Provider container={container}>
      <RouterProvider
        router={router}
        context={{
          auth,
        }}
      />
      <Toaster richColors position="top-center" />
    </Provider>
  )
}
